import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import Navbar from '../../../components/navbar/ui/Navbar';
import Footer from '../../../components/footer/ui/Footer';
import ScrollToTop from '../../../components/scroll-to-top/ui/ScrollToTop';
import SEO from '../../../components/seo/SEO';
import ServiceDetailSection from '../components/ui/ServiceDetailSection';
import { servicesData } from '../data/servicesData';
import { getServiceSEO } from '../../../../data/seoData';

const ServiceDetailPage: React.FC = () => {
    const { serviceSlug } = useParams<{ serviceSlug: string }>();

    // Scroll to top when service changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [serviceSlug]);

    // Check if service exists
    if (!serviceSlug || !servicesData[serviceSlug]) {
        // Redirect to workshop page if service not found
        return <Navigate to="/oficina" replace />;
    }

    const service = servicesData[serviceSlug];
    const seo = getServiceSEO(serviceSlug);

    return (
        <>
            <SEO 
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
                canonical={seo.canonical}
            />
        <div className="service-detail-page">
            <Navbar />
            <ServiceDetailSection key={serviceSlug} service={service} />
            <Footer />
            <ScrollToTop />
        </div>
        </>
    );
};

export default ServiceDetailPage;

